import { ComponentProps, ComponentType, ReactNode } from 'react';

import ArrowLeft from '@synapex/frontend-shared/icons/arrow-left-20.svg?react';
import ArrowRight from '@synapex/frontend-shared/icons/arrow-right-24.svg?react';

import { Checkbox2Radio } from '@/true-fsd/shared/ui/Checkbox2';

import { NavigateFunction, useNavigate } from 'react-router';
import classes from './WorkspaceTypeSelect.module.scss';
import { useNewWsStore } from '@/true-fsd/data/advertiser-account/new-workspace-store';

const OPTIONS = [
  { value: 'site' as const, label: 'На сайт' },
  { value: 'channel' as const, label: 'На канал' },
];

type OptValue = (typeof OPTIONS)[number]['value'];

type RenderLayoutProps = {
  slotHeader: ReactNode;
  slotTitle: ReactNode;
  slotButtons: ReactNode;

  children: ReactNode;
};

type ButtonProps = {
  navigate: NavigateFunction;
  value: OptValue;
  PrefixIcon?: ComponentType<ComponentProps<'svg'>>;
  SuffixIcon?: ComponentType<ComponentProps<'svg'>>;
  variant: 'primary' | 'secondary';
  children: ReactNode;
};

export type WorkspaceTypeSelectProps = {
  RenderLayout: (p: RenderLayoutProps) => ReactNode;
  RenderBack: (p: ButtonProps) => ReactNode;
  RenderForward: (p: ButtonProps) => ReactNode;
};
export const WorkspaceTypeSelect = ({
  RenderBack,
  RenderForward,
  RenderLayout,
}: WorkspaceTypeSelectProps) => {
  const navigate = useNavigate();
  const { workspace_type, setWorkspaceType } = useNewWsStore(
    ({ workspace_type, setWorkspaceType }) => ({
      workspace_type,
      setWorkspaceType,
    }),
  );

  return (
    <RenderLayout
      slotHeader={'Добавление целевой ссылки'}
      slotTitle={
        <>
          Выберите, куда планируете
          <br /> вести трафик
        </>
      }
      slotButtons={
        <div className={classes.buttons}>
          <RenderBack
            PrefixIcon={ArrowLeft}
            variant={'secondary'}
            value={workspace_type}
            navigate={navigate}
          >
            Назад
          </RenderBack>
          <RenderForward
            SuffixIcon={ArrowRight}
            variant={'primary'}
            value={workspace_type}
            navigate={navigate}
          >
            Далее
          </RenderForward>
        </div>
      }
    >
      <Checkbox2Radio
        options={OPTIONS}
        value={workspace_type}
        onChange={setWorkspaceType}
      />
    </RenderLayout>
  );
};
